export function transformOptions({ options, values, disabledValues, identifier, }) {
    return options.map((item) => {
        const id = identifier(item);
        const selected = values.includes(id);
        const disabled = !!disabledValues.includes(id);
        return {
            id,
            item,
            selected,
            disabled,
        };
    });
}
